import fuzzysort from 'fuzzysort';
import {isNull, isUndefined} from 'lodash';
import React, {FC} from 'react';

import {HighlightRangeModel} from '../../../../../../models/api/conversationHighlightModel';
import {Highlight} from './highlight';

/*
 * Props.
 */

interface FuzzyHighlightProps {
  text?: string;
  fuzzy?: Fuzzysort.Result;
  query?: string;
}

/*
 * Components.
 */

/** Highlight results from Fuzzy Lib */
export const FuzzyHighlight: FC<FuzzyHighlightProps> = ({text, fuzzy, query}) => {
  let result: Fuzzysort.Result | undefined;
  if (isUndefined(text) || (isUndefined(fuzzy) && isUndefined(query))) {
    return <>{text}</>;
  }

  if (isUndefined(fuzzy) && !isUndefined(query)) {
    [result] = fuzzysort.go(query, [text]);
  }

  const fuzzyIndexes = (result && result.indexes) || (fuzzy && fuzzy.indexes);
  const highlightRanges = fuzzyHighlightToHighlightRanges(fuzzyIndexes);
  return <Highlight text={text} ranges={highlightRanges} />;
};

/*
 * Helpers.
 */

/**
 * Transform an array of indexes to highlight : [1, 2, 3, 5, 6, 8] (fuzzysort library format)
 * into an array of highlight ranges: [{start: 1,length: 3},{start: 5,length: 2},{start: 8,length: 1}] (<Highlight> component format)
 */
export function fuzzyHighlightToHighlightRanges(
  fuzzyHighlight?: ReadonlyArray<number>,
): ReadonlyArray<HighlightRangeModel> {
  if (isUndefined(fuzzyHighlight) || isNull(fuzzyHighlight) || !fuzzyHighlight.length) {
    return [];
  }

  // Init
  const highlightRanges: Array<HighlightRangeModel> = [];

  let currentIndex = 0;
  let start = fuzzyHighlight[currentIndex];
  let length = 1;
  while (currentIndex < fuzzyHighlight.length) {
    // Increment length while next value is equal to current value + 1
    while (fuzzyHighlight[currentIndex] + 1 === fuzzyHighlight[++currentIndex]) {
      length++;
    }

    // Push the new highlight range
    highlightRanges.push({start, length});

    // Init next highlight range
    start = fuzzyHighlight[currentIndex];
    length = 1;
  }

  return highlightRanges;
}
